// components
import { Fade } from '@mui/material';

// styles
import {
  StyledFilterPopperWrapperBox,
  StyledFilterPopperWrapperPopper
} from './FilterPopperWrapper.styles';

// types
import { FilterPopperWrapperProps } from './FilterPopperWrapper.types';

export function FilterPopperWrapper({
  pinned,
  filterPopoverId,
  getAnchorEl,
  pinnedRect,
  children,
  customZIndex
}: FilterPopperWrapperProps) {
  if (pinned) {
    return (
      <StyledFilterPopperWrapperBox pinnedRect={pinnedRect}>
        {children}
      </StyledFilterPopperWrapperBox>
    );
  }

  const anchorElFn = getAnchorEl
    ? (): HTMLElement => {
        const el = getAnchorEl();
        if (!el) {
          return document.body;
        }
        return el;
      }
    : undefined;

  const anchor = getAnchorEl?.() ?? null;
  const open = Boolean(filterPopoverId && anchor);

  return (
    <StyledFilterPopperWrapperPopper
      id={filterPopoverId}
      open={open}
      anchorEl={anchorElFn}
      placement="bottom-start"
      modifiers={[
        { name: 'computeStyles', options: { gpuAcceleration: false } }
      ]}
      customZIndex={customZIndex}
      transition
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={250}>
          {children}
        </Fade>
      )}
    </StyledFilterPopperWrapperPopper>
  );
}
